// Lightweight browser detection helpers (no external deps)

export const isSafari = () => {
    if (typeof window === 'undefined') return false;
    const ua = window.navigator.userAgent;

    // Safari UA always contains BOTH "Version/X.Y" AND "Safari/X.Y"
    //   e.g.  "...Version/17.0 Safari/605.1.15"
    //
    // Chrome UA contains "Safari/537.36" but NEVER "Version/X.Y"
    //   e.g.  "...Chrome/120.0.0.0 Safari/537.36"
    //
    // This is the most reliable way to detect real Safari because:
    //   - window.chrome is undefined in PWA standalone mode
    //   - navigator.vendor can be unreliable across platforms
    //   - UA "Chrome" token may be absent in some Chromium forks
    //   - But ONLY real Safari includes "Version/" in the UA string

    const hasVersionToken = /Version\/[\d.]+/i.test(ua);
    const hasSafariToken = /Safari/i.test(ua);
    const isFirefox = /Firefox|FxiOS/i.test(ua);

    return hasVersionToken && hasSafariToken && !isFirefox;
};
